<template>
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span>Payment</span>
              </li>
            </ol>
          </div>
          <h2 class="font-light m-b-xs">
            Create LEA account
          </h2>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row" >
        <div class="col-lg-12">
          <div class="hpanel">
            <div class="panel-body info">

              <h3 class="font-bold text-center">LEA is the platform to connect to internal (Edison) and external expertise</h3>
              <p class="text-center m-b">
                LEA : Look for Expertise Access
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row" >
        <div class="col-xs-10 col-xs-offset-1">
          <div class="hpanel">
            <div class="panel-body">
              <div class="row" style="margin-bottom: 15px" v-if="role === 'seeker' || role === 'broker'">
                <div class="col-xs-12 text-center">
                  <template v-if="$user.isBasic() || (!$auth.check('seeker') && role === 'seeker') || (!$auth.check('broker') && role === 'broker') ">
                    <a role="button" data-toggle="modal"  data-target="#modalActivateAccount" class="btn btn-info">Activate my {{role}} account</a>
                    <div style="margin-top: 15px">Your will be able to use your account immediately. The first 25 searches are free. Your purchase order must reach us beyond that.</div>
                  </template>
                  <template v-else>
                    <div class="text-info font-bold">
                      Your account is activated ! Start your first project by clicking on My Dashboard or My Project menu item.
                    </div>
                  </template>
                </div>
              </div>
              <h4>
                To get a LEA account, you should use the local procurement application (ie: Coupa) by using the following <span style="color: #4fa600">data</span>:
              </h4>
              <div>
                <table class="table" style="margin-top: 25px">
                  <tbody>
                  <tr>
                    <td>
                      <div><b>Name of the product</b> <span style="font-style: italic;">(Look for Expertise Access - Open Innovation_ Application)</span> :</div>
                    </td>
                    <td><span style="color: #4fa600"><b>LEA-OI_ Application</b></span></td>
                  </tr>
                  <tr>
                    <td>
                      <div><b>Access:</b></div>
                    </td>
                    <td><span style="color: #4fa600"><b>https://lea.idexlab.com/</b></span></td>
                  </tr>
                  <tr>
                    <td>
                      <div><b class="text-info">Vendor name</b> (Supplier) :</div>
                    </td>
                    <td><span style="color: #4fa600"><b>ideXlab</b> / 75013 Paris FR</span></td>
                  </tr>
                  <tr>
                    <td>
                      <div><b>Reference of Supplier</b> <span style="font-style: italic;">(local code for FR)</span> :</div>

                    </td>
                    <td><span style="color: #4fa600"><b>638 193</b></span></td>
                  </tr>
                  <tr>
                    <td>
                      <div><b class="text-info">Vendor ID</b> <span style="font-style: italic;">(for Central Procurement System)</span> :</div>

                    </td>
                    <td><b><span style="color: #4fa600">10 250 710</span></b></td>
                  </tr>
                  <tr>
                    <td colspan="2"><u><h4 class="font-bold">Conditions:</h4></u>
                      <ul class="m-l-md" >
                        <li class="m-b-sm"><b class="m-b-xs">For Seeker account : License for <span
                        style="color: #4fa600">1 year, for 365 days </span>duration, date to date</b>
                          <ul>
                            <li>
                              <b class="text-info">Price</b><b> for <span style="color: #4fa600">Seeker account = 450 €</span></b>
                            </li>
                          </ul>
                        </li>
                        <li><b class="m-b-xs">For Broker account (Open Innovation project) please contact ideXlab team: <span class="text-info"><a href="mailto:lea.se@idexlab.com"></a>lea.se@idexlab.com</span> or
                          Offer Creation team through OCP portal.</b>
                          <ul>
                            <li>You will have access to guidance & assistance to execute a complete open innovation project according to the workflow provided by the LEA platform and ideXlab team.
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"><u><h4 class="font-bold">Procurement process:</h4></u>
                      <p>
                        With the Basic account (free Simple Search for users), each user will have 25 free searches to
                        experiment the Seeker account. To upgrade to Seeker account service, user needs to order a
                        Seeker license.
                      </p>
                      <u> Two possibility to order: </u>
                      <ul style="list-style-type: decimal" class="m-l-md m-t">
                        <li class="m-b-sm">Through Coupa tool: please state clearly in the request:<br>
                          Vendor name; Vendor ID; Price; Requested date; name and e-mail address of license user
                        </li>
                        <li class="m-b-sm">Through local ordering process, if Coupa not available, please state clearly
                          in the request:<br>
                          Vendor name; Vendor ID; Price; Requested date; name and e-mail address of license user
                        </li>
                      </ul>
                      <div class=" row alert alert-warning">
                        <div class="col-xs-1 m-t-sm"><i class="fa fa-warning fa-2x"></i></div>
                        <div class="col-xs-11 ">
                          Ordering process lead time might fluctuate depending on organization & location.<br>
                          Please consider 2 weeks lead time to anticipate your request and not discontinue Seeker
                          service access.<br>
                          Please check with your local indirect procurement team for order processing support.
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <h5>Comments:</h5>
                <ul>
                  <li class="m-b-sm">ideXlab contact for LEA procurement: <span class="text-info">lea.se@idexlab.com</span></li>
                  <li class="m-b-sm">E-mail address to send Purchase Order processed outside “Coupa” application : <span class="text-info">compta@idexlab.com</span></li>
                  <li class="m-b-sm">Other information: <a class="text-info" href="https://www.idexlab.com/corporate/" target="_blank">https://www.idexlab.com</a></li>
                </ul>
              </div>
            </div>

          </div>

        </div>
      </div>
      <div id="modalActivateAccount" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="color-line"></div>
            <div class="modal-header">
              <h4 class="modal-title">LEA {{role}} account</h4>
            </div>
            <div class="modal-body">
              <h3>Are you sure you want to activate your {{role}} account ?</h3>
              <div>
                <span>Your will be able to use your account immediately. The first 25 searches are free. Your purchase order must reach us beyond that.</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-success" :data-style="submit.dataStyle" v-on:click="activeAccount">Continue</vue-ladda>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  components: {
    VueLadda
  },
  name: 'LeaPayment',
  data () {
    return {
      role: this.$route.params.role,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    activeAccount (event) {
      event.preventDefault()

      this.axios.post('payment/se/activation', {role: this.role})
        .then(() => {
          this.$auth.fetch()
          this.$notify({
            type: 'success',
            title: 'Congratulations',
            content: 'your account has been activated!',
            placement: 'bottom-right'
          })
        }).catch((error) => {
          if (error.response.data.code === 1) {
            this.$notify({
              type: 'danger',
              title: 'An error has occurred',
              content: 'Maybe you try to do something wrong ?',
              placement: 'bottom-right'
            })
          } else if (error.response.data.code === 2) {
            this.$notify({
              type: 'danger',
              title: 'An error has occurred',
              content: 'Only a broker, seeker or basic can subscribe to broker/seeker account',
              placement: 'bottom-right'
            })
          }
        })
        .finally(() => {
          $('#modalActivateAccount').modal('hide')
          this.submit.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/plan/LeaPayment.vue